module.exports = __webpack_public_path__ + "img/loesungen-fuer-jede-lebenslage_kachl_MENTALPOWER.d072cef4.png";